import { render, staticRenderFns } from "./ArriveCustomers.vue?vue&type=template&id=4fa30469"
import script from "./ArriveCustomers.vue?vue&type=script&lang=js"
export * from "./ArriveCustomers.vue?vue&type=script&lang=js"
import style0 from "./ArriveCustomers.vue?vue&type=style&index=0&id=4fa30469&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports